// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WSyt","inner":"Footer_inner__3HigO"};